import React, { Component } from 'react'
import './Skeleton.css'

/*
	Écrans de chargement « squelette » : des blocs pulsés aux dimensions du
	contenu final, pour éviter tout saut de layout au remplacement.

	Variantes :
	- page  : cover 25vh + cartes de sections (Pages, Categories)
	- home  : bannière + groupes de tuiles catégories (Home)
	- cards : bannière + cartes horizontales (Services, Animations)
	- list  : lignes avatar + texte (Notifications, Compte)

	L'animation shimmer est désactivée si l'utilisateur préfère réduire
	les animations (prefers-reduced-motion).
*/
class Skeleton extends Component
{
	render()
	{
		const variant = this.props.variant
		const classname = (this.props.className) ? " " + this.props.className : ""
		if (variant === "home")
		{
			return (
				<div className={"sk-screen" + classname}>
					<div className="sk-home-banner sk-anim"></div>
					<div className="sk-home-content">
						<div className="sk-title-line sk-anim"></div>
						<div className="sk-tile-row">
							<div className="sk-tile sk-anim"></div>
							<div className="sk-tile sk-anim"></div>
							<div className="sk-tile sk-anim"></div>
						</div>
						<div className="sk-title-line sk-anim"></div>
						<div className="sk-tile-row">
							<div className="sk-tile sk-anim"></div>
							<div className="sk-tile sk-anim"></div>
							<div className="sk-tile sk-anim"></div>
						</div>
					</div>
				</div>
			)
		}
		if (variant === "cards")
		{
			return (
				<div className={"sk-screen" + classname}>
					<div className="sk-home-banner sk-anim"></div>
					<div className="sk-cards-content">
						<div className="sk-row">
							<div className="sk-circle sk-anim"></div>
							<div className="sk-lines">
								<div className="sk-line sk-anim"></div>
								<div className="sk-line w60 sk-anim"></div>
							</div>
						</div>
						<div className="sk-row">
							<div className="sk-circle sk-anim"></div>
							<div className="sk-lines">
								<div className="sk-line sk-anim"></div>
								<div className="sk-line w60 sk-anim"></div>
							</div>
						</div>
						<div className="sk-row">
							<div className="sk-circle sk-anim"></div>
							<div className="sk-lines">
								<div className="sk-line sk-anim"></div>
								<div className="sk-line w60 sk-anim"></div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		if (variant === "list")
		{
			const rows = []
			for (let i = 0; i < 5; i++)
			{
				rows.push(
					<div className="sk-row" key={i}>
						<div className="sk-circle sk-anim"></div>
						<div className="sk-lines">
							<div className="sk-line sk-anim"></div>
							<div className="sk-line w60 sk-anim"></div>
						</div>
					</div>
				)
			}
			return (<div className={"sk-list" + classname}>{rows}</div>)
		}
		return (
			<div className={"sk-screen" + classname}>
				<div className="sk-page-cover sk-anim"></div>
				<div className="sk-page-content">
					<div className="sk-block tall sk-anim"></div>
					<div className="sk-block medium sk-anim"></div>
					<div className="sk-block short sk-anim"></div>
				</div>
			</div>
		)
	}
}

export default Skeleton
